import {
  sequence_repository,
} from '@/repositories';

const state = () => ({
  sequence_target_lists: [],
});

const getters = {
  sequenceTargetLists: (state) => state.sequence_target_lists,
};

const actions = {

  async addTargetLists({ commit }, input) {
    const response = await sequence_repository.addTargetLists(input);

    commit('add_sequence_target_list', response);

    return response;
  },

  async searchTargetLists({ commit }, sequence_id) {
    const response = await sequence_repository.searchTargetLists(sequence_id);

    commit('set_sequence_target_list', response);

    return response;
  },
};

const mutations = {
  add_sequence_target_list(state, new_target_list) {
    state.sequence_target_lists.push(new_target_list);
  },
  set_sequence_target_list(state, result_target_lists) {
    state.sequence_target_lists = result_target_lists;
  },
};

export default {
  actions,
  getters,
  mutations,
  namespaced: true,
  state,
};
